import { toast } from "sonner";
import { Pencil, RefreshCw, Trash2 } from "lucide-react";
import { api, errMsg, formatDate, imgUrl } from "@/lib/api";

const STATUS = {
  pending: ["Waiting for review", "bg-[#f7efe1] text-[#6b4a14]"],
  approved: ["Live", "bg-[#eef3ee] text-[#1f402b]"],
  rejected: ["Not approved", "bg-[#fbeaea] text-[#7a1d1d]"],
  removed: ["Taken down", "bg-[#f4f0ea] text-[#5a665e]"],
  expired: ["Expired", "bg-[#f4f0ea] text-[#5a665e]"],
};

const effective = (l) => (l.status === "approved" && l.expires_at && new Date(l.expires_at) < new Date() ? "expired" : l.status);

export default function MyListings({ listings, onEdit, reload }) {
  const act = async (fn, msg) => {
    try {
      await fn();
      toast.success(msg);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  if (!listings.length) return <p className="border border-[#e2dcd4] bg-white p-6 text-sm text-[#5a665e]" data-testid="seller-listings-empty">No adverts yet.</p>;
  return (
    <div className="border border-[#e2dcd4] bg-white divide-y divide-[#e2dcd4]" data-testid="seller-listings">
      {listings.map((l) => {
        const st = effective(l);
        const [text, cls] = STATUS[st];
        return (
          <div key={l.id} className="p-4 flex items-center gap-4" data-testid={`seller-listing-${l.id}`}>
            {l.images?.[0] ? <img src={imgUrl(l.images[0])} alt="" className="w-16 h-12 object-cover hidden sm:block" /> : <div className="w-16 h-12 bg-[#f4f0ea] hidden sm:block" />}
            <div className="flex-1 min-w-0">
              <p className="truncate text-[#1a261f]">{l.title}</p>
              <p className="font-mono-k text-[11px] text-[#5a665e]">
                {st === "approved" ? `Live until ${formatDate(l.expires_at)}` : st === "rejected" && l.review_reason ? l.review_reason : l.category}
              </p>
            </div>
            <span className={`font-mono-k text-[10px] uppercase tracking-widest px-2 py-1 whitespace-nowrap ${cls}`} data-testid={`seller-listing-status-${l.id}`}>{text}</span>
            {(st === "approved" || st === "expired") && (
              <button onClick={() => act(() => api.post(`/seller/listings/${l.id}/renew`), "Renewed for 30 more days. 1 credit used")} title="Renew for 30 days (1 credit)"
                className="p-2 text-[#5a665e] hover:text-[#1f402b]" data-testid={`seller-listing-renew-${l.id}`}><RefreshCw size={15} /></button>
            )}
            {st !== "removed" && st !== "rejected" && (
              <>
                <button onClick={() => onEdit(l)} title="Edit" className="p-2 text-[#5a665e] hover:text-[#1f402b]" data-testid={`seller-listing-edit-${l.id}`}><Pencil size={15} /></button>
                <button onClick={() => window.confirm("Take this advert down? This can't be undone.") && act(() => api.delete(`/seller/listings/${l.id}`), "Advert taken down")}
                  title="Take down" className="p-2 text-[#5a665e] hover:text-[#991b1b]" data-testid={`seller-listing-remove-${l.id}`}><Trash2 size={15} /></button>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
